<script setup lang="ts">
import { StudentAttendanceInterface } from '@/types';
import { toRefs } from 'vue';

interface StudentsPropsInterface {
  lowAttendance: boolean;
  student: StudentAttendanceInterface;
  skey: string;
  selected: boolean;
}

const props = defineProps<StudentsPropsInterface>();
const { student, selected, skey } = toRefs(props);
const emit = defineEmits(['studentSelected']);

const onSelectStudent = (student: StudentAttendanceInterface, key: string) => {
  emit('studentSelected', student, key);
};
</script>

<template>
  <div
    :key="student.id"
    class="mb-2 font-bold border-round-lg cursor-pointer"
    :class="{ 'selected bg-primary-lighter': selected, ' p-1 surface-100 raised': !selected }"
    @click="onSelectStudent(student, skey)"
  >
    <p class="flex align-items-center p-1 justify-content-between w-full" style="height: 28px">
      <span>{{ student.full_name }}</span>
      <span :class="{ 'text-alert-red': lowAttendance }">{{ student.percentage }}%</span>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.selected {
  border: 4px solid var(--primary-color-light);
  border-radius: 8px;
}
.text-alert-red {
  color: $errorColor;
}
.bg-primary-lighter {
  background: var(--primary-color-light);
}
</style>
